import { jsx as _jsx } from "react/jsx-runtime";
import Search from "../../Search";
import { SearchVariant } from "../../Search/types";
const AppBarSearch = ()=>{
    return /*#__PURE__*/ _jsx(Search, {
        variant: SearchVariant.DESKTOP
    });
};
export default AppBarSearch;
